export default {
    manage_createEditVehicleStatus_EditTitle: "Editar Etiqueta de Estado",
    manage_createEditVehicleStatus_CreateTitle: "Crear nueva Etiqueta de Estado",
    manage_createEditVehicleStatus_warning: "realiza un cambio para poder guardar",
    manage_createEditVehicleStatus_warning_characters: "El nombre contiene caracteres no permitidos, realiza un cambio",
    manage_createEditVehicleStatus_success: "Etiqueta de Estado fue creada exitosamente",
    manage_createEditVehicleStatus_success_edit: "Etiqueta de Estado fue actualizada exitosamente",
    manage_createEditVehicleStatus_NameInputLabel: "Etiqueta de Estado",
    manage_createEditVehicleStatus_IconInputLabel: "Icono",
    manage_createEditVehicleStatus_duplicatedVehicleStatusErrorMessage: "Esta Etiqueta de Estado ya existe",
  };
  